import { useMutation } from "react-query";
import API, { IApi } from "../services/API";
import { getActuApiEndpoint } from "../services/Config";

export const useActualites = () => {
  const api: IApi = API.create(getActuApiEndpoint());

  return useMutation<any, any, string>(
    // @ts-ignore
    (params: string) =>
      (api &&
        api.getActualites(params)) ||
      undefined,
  );
};